var path = 'components/subscribers/tooltips/subscriptionLength.html';
var html = "<div style=width:70px;height:80px><b>Y</b>: Years <b>M</b>: Months <b>W</b>: Weeks <b>D</b>: Days</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;